import SearchResultItem from "./SearchResultItem";

// functionality is same as SearchResultItem
export default SearchResultItem;